<!--自定义表头显示  -->
<template>
	<div class="dialogBox">
		<el-dialog title="自定义表头显示" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="600px" top="3vh" :before-close="cancle">
			<div class="mt10">
					<el-table :data="tableData" v-if="tableData.length>0" ref="multipleTable"
					:header-cell-style="{background:'#C8CCD7',color:'#333333',height:'25px'}"
					 @selection-change="handleSelectionChange"
					 border height="405" style="width: 100%">
					  <el-table-column
						prop="myShowSort"
						label="序号"
						width="60">
					</el-table-column>
					<el-table-column type="selection" width="60" align="center">
					</el-table-column>
					 <el-table-column
						prop="showName"
						label="表头"
						>
					</el-table-column>
					<!--   -->
					<el-table-column fixed="right" label="调序" width="100">
						<template slot-scope="scope">
							<i class="el-icon-bottom ml15 opeartion" @click="sortDown(scope.row,2)"
								v-if="(scope.$index+1)!=tableData.length"></i>
							<i class="el-icon-top ml15 opeartion" @click="sortDown(scope.row,1)"
								v-if="scope.$index>0"></i>
						</template>
					</el-table-column>
				</el-table>
				<div v-else class="tc mt15">暂无数据</div>
			</div>


			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				tableData:[],
				multipleSelection: [],
			}
		},
		created() {

		},
		methods: {
			init() {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.getList()
				})
			},
			
			// 获取列表
			getList() {
				let that = this;
				that.$request.post(
						"getHeaderList",
						true, {}
					)
					.then((res) => {
				
							if (res && res.data.length > 0) {
								that.tableData = res.data
								setTimeout(()=>{
									that.tableData.forEach(item => {
									if(item.isShow==1){
										that.$refs.multipleTable.toggleRowSelection(item)
										}
									});
									that.$forceUpdate()
								},100)
								
							} else {
								that.tableData = []
							}
						
					})
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 上移下移
			sortDown(row, val) {
				let that = this;
				that.$request.post(
						"orderSort",
						false, {
							recordId: row.recordId,
							fieldName: row.fieldName,
							removeFlag: val
						}
					)
					.then((res) => {
						if (res) {
							that.$message.success(val == 1 ? '上移成功！' : '下移成功！');
							that.getList()
						}
					})
			},
			// 保存
			saveHeader() {
				let that = this;
				that.$request.post(
						"saveHeader",
						true, {
							myViewFormList: that.tableData,
						}
					)
					.then((res) => {
						if (res) {
							that.$message.success( '保存成功！');
							that.dialogVisible = false
							that.$emit("getList")
						}
					})
			},
			// 保存
			submitForm: debounce(function () {
				let arr=[]
				this.multipleSelection.forEach(item => {
					arr.push(item.recordId)
				});
				this.tableData.forEach(row => {
					if(arr.includes(row.recordId))
					{
						row.isShow = 1
					}else{
						row.isShow = 0
					}
				});
				this.saveHeader()

			}, 1000, true),
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 10px 20px;
		}

		/deep/ .el-radio .el-radio__label {
			display: none;
		}
	}



	.w225 {
		width: 225px;
	}

	.sort-box {
		justify-content: center;
		line-height: 40px;
		font-size: 16px;
	}
	
		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 5px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
		}

</style>
